<template lang="html">
    <div class="field">
        <label class="label" v-text="label"></label>
        <p class="control" :class="(icon)? 'has-icon '+iconAlign:'' ">
            <span class="select" :class="{'is-danger' : error, 'is-medium' : size === 'medium' , 'is-small':size === 'small', 'is-loading' : loading , 'is-large' : size === 'large'}">
                <select :name="name" @input="update($event.target.value)" :disabled="disabled" :readonly="readonly" :value.sync="value">
                    <option value="" selected disabled>{{ holder }}</option>
                    <option v-for="option in options" :value="option[val]" v-text="option[text]"></option>
                </select>
            </span>
            <span class="icon is-small" v-if="icon">
                <i :class="'fa ' + icon"></i>
            </span>
        </p>
        <p class="help is-danger" v-if="error">{{ error[0] }}</p>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    props: {
        label: {
            type: String,
        },
        text: {
            default: 'label',
            type: String,
        },
        val: {
            default: 'value',
            type: String,
        },
        label: {
            type: String,
        },
        name: {
            type: String,
        },
        holder: {
            type: String,
            default: 'Selecciona un elemento'
        },
        size: {
            type: String,
        },
        value: {

        },
        disabled: {

        },
        readonly: {

        },
        error: {
            type: Array,
        },
        options: {
            type: Array,
        },
        icon: {
            type: String,
        },
        iconAlign: {
            type: String,
            default: 'has-icon-right',
        },
        loading: {
            type: Boolean,
            default: false,
        }
    },
    watch: {
      value(value) {
        this.$emit('input', value);
      }
    },
    methods: {
        update(value) {
            this.$emit('input', value);
        },
    }
}
</script>

<style lang="css">
</style>
